// extracted by mini-css-extract-plugin
export default {"content":"src-views-analytics-components-ProfileKPIs-ProfileKPIs__content--y5qbN"};